module.exports = __webpack_public_path__ + "img/Header4.af11335e.jpg";